/* eslint-disable no-console */

import { register } from 'register-service-worker'

/**
 * Nome do evento que avisa a aplicação de que há build novo esperando.
 *
 * Este arquivo roda FORA do Vue — é chamado pelo `main.js` antes de a
 * aplicação existir —, então não dá para importar um store nem emitir num bus
 * de componente. Um `CustomEvent` no `window` é a ponte que não cria
 * dependência nenhuma nos dois sentidos.
 *
 * O `detail` carrega o `registration`, porque quem for mostrar o aviso precisa
 * dele para mandar o service worker em espera assumir (`SKIP_WAITING`).
 */
export const EVENTO_ATUALIZACAO = 'footie:atualizacao-disponivel'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },

    // ------------------------------------------------------------- O CONSERTO
    //
    // Este gancho é o momento em que o navegador SABE que existe build novo — e
    // até 2026-09-02 ele só escrevia no console.
    //
    // O efeito de não avisar não é "o usuário fica com a versão antiga por um
    // tempo": o service worker do @vue/cli-plugin-pwa faz precache do app e
    // continua servindo o `index.html` ANTIGO, que referencia bundles com hash
    // antigo. Publicado o build novo, aqueles arquivos deixam de existir, o
    // carregamento falha e **a tela fica em branco**.
    //
    // Foi exatamente o que aconteceu em 2026-08-13 no staging, e enganou o
    // diagnóstico: `curl` mostrava tudo certo, o deployment estava `success`, e
    // só quebrava em navegador que já tinha visitado o site. Um navegador
    // limpo recebe a versão nova na hora.
    //
    // Até as abas do site serem TODAS fechadas, o service worker novo fica em
    // `waiting` e o antigo segue no comando. Num produto que roda em celular e
    // fica aberto em aba, isso é indefinido.
    updated (registration) {
      console.log('New content is available; please refresh.')
      window.dispatchEvent(
        new CustomEvent(EVENTO_ATUALIZACAO, { detail: { registration } })
      )
    },

    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
